import React, { useContext, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { withRouter, Link } from 'react-router-dom';
import { withAuth } from '@cdk-prod/fortellis-auth-context';
import { withEntityContext } from '@cdk-prod/fortellis-entity-context';
import { Header } from '@fortellis/header';
import config from '../../config/config';
import './header.scss';
import { locationContext } from '../locationContext';

const CASE_MANAGEMENT_NAV_ITEM = 'case-management';

function AuthHeader({ auth, entityContext, mobile, onAuthAndEntityInit }) {
  const { setCurrentLocation } = useContext(locationContext);

  useEffect(() => {
    onAuthAndEntityInit(entityContext, auth);
  }, [entityContext?.entity?.id, auth]);

  const filteredNav = useMemo(() => {
    const nav = { ...config.nav };

    if (process.env.REACT_APP_NAV_CASE_MANAGEMENT_ENABLED !== 'true') {
      return nav;
    }

    const currentOrgId = entityContext?.entity?.id;
    const whitelistedOrgs =
      process.env.REACT_APP_CASE_MANAGEMENT_WHITELISTED_ORGS || '';
    const whitelistedOrgIds = whitelistedOrgs
      .split(',')
      .map(id => id.trim())
      .filter(Boolean);

    const shouldShowCaseManagement =
      auth.isAuthenticated &&
      currentOrgId &&
      whitelistedOrgIds.length > 0 &&
      whitelistedOrgIds.includes(currentOrgId);

    if (!shouldShowCaseManagement && nav.user && nav.user.menu) {
      nav.user = {
        ...nav.user,
        menu: nav.user.menu.filter(
          item => item.code !== CASE_MANAGEMENT_NAV_ITEM
        )
      };
    }

    return nav;
  }, [auth.isAuthenticated, entityContext?.entity?.id]);

  return (
    <Header
      className="api-dir-header"
      mobile={mobile}
      authenticated={auth.isAuthenticated}
      entityContext={entityContext}
      login={() => {
        setCurrentLocation();
        auth.login();
      }}
      logout={auth.logout}
      nav={filteredNav}
      routerLink={Link}
      selectedKey="apis"
      signup={config.signup.url}
      user={auth.userData}
    />
  );
}

AuthHeader.propTypes = {
  auth: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired
};

export default withRouter(withAuth(withEntityContext(AuthHeader)));
